"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SourceHoverButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireWildcard(require("prop-types"));
var _SourceHoverButton = require("./SourceHoverButton.styled");
var _ = require("../..");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _useTranslate2 = require("../../locales/useTranslate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SourceHoverButton = exports.SourceHoverButton = function SourceHoverButton(_ref) {
  var source = _ref.source,
    onTogglePlay = _ref.onTogglePlay,
    onSetSourceLive = _ref.onSetSourceLive,
    layout = _ref.layout;
  var sourceId = source._id,
    type = source.type;
  var iconShouldBeActive = layout === _.SINGLE.id;
  var targetElementId = "program-solo-icon-".concat(sourceId);
  var _useTranslate = (0, _useTranslate2.useTranslate)(),
    translate = _useTranslate.translate;
  var toolTipText = translate('Source_Spotlight_Popover');
  var onClick = function onClick() {
    var PLAY = 'play';
    onSetSourceLive(source);
    if ([_.VIDEO_FILE, _.AUDIO_FILE].includes(type)) {
      onTogglePlay(sourceId, PLAY);
    }
  };
  return /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.Wrapper, null, /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.StyledButton, {
    "data-testid": "program-solo-button-".concat(sourceId),
    onClick: onClick,
    isActive: iconShouldBeActive
  }, /*#__PURE__*/_react["default"].createElement(_SourceHoverButton.StyledSoloIcon, {
    id: targetElementId,
    icon: _freeSolidSvgIcons.faMaximize,
    isActive: iconShouldBeActive
  })), /*#__PURE__*/_react["default"].createElement(_.ToolTip, {
    targetElement: targetElementId,
    message: toolTipText,
    placement: "bottom",
    noPointerEvent: true
  }));
};
SourceHoverButton.propTypes = {
  source: _propTypes.object,
  onTogglePlay: _propTypes["default"].func.isRequired,
  onSetSourceLive: _propTypes["default"].func.isRequired,
  layout: _propTypes["default"].string
};